import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

declare global {
  interface Window {
    ScarabQueue?: any[]
  }
}

export default defineNuxtPlugin(() => {
  const gdprCookies = useCookie<string>('gdpr_settings', { ...COOKIE_OPTIONS, watch: true })
  const runtimeConfig = useRuntimeConfig()

  const sapID = runtimeConfig.public.sapID as string | undefined

  if (!sapID) {
    console.warn('SAP ID is not defined')
    return
  }

  const { load, unload } = useScriptTag(`https://cdn.scarabresearch.com/js/${sapID}/scarab-v2.js`, undefined, {
    manual: true,
    attrs: { id: 'scarab-js-api' }
  })

  const injectSapHead = async () => {
    const hasWeb = !!gdprCookies.value && gdprCookies.value.includes('web')
    if (hasWeb) {
      window.ScarabQueue = window.ScarabQueue || []
      await load()
      useHead({
        script: [
          {
            key: 'scarab-end',
            tagPosition: 'bodyClose',
            children: "window.ScarabQueue.push(['go']);"
          }
        ]
      })
    } else {
      useHead({
        script: [
          {
            key: 'scarab-end',
            tagPosition: 'bodyClose',
            children: ''
          }
        ]
      })
      if (document.getElementById('scarab-js-api')) unload()
      window.ScarabQueue = []
    }
  }

  injectSapHead()

  watch(gdprCookies, () => {
    injectSapHead()
  })
})
